import { useState } from "react";
import useReveal from "../hooks/useReveal";
import "remixicon/fonts/remixicon.css";
import "./Contact.css";
import { Helmet } from 'react-helmet-async';


const heroImg = "/images/abouthero.webp";

export default function Contact() {
  useReveal();

const [activeForm, setActiveForm] = useState("distributor");
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState({});

  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [distForm, setDistForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    business: "",
    years: "",
    message: "",
  });

  const hc = (e) => {
    const { name, value } = e.target;

    if (activeForm === "contact") {
      setContactForm({ ...contactForm, [name]: value });
    } else {
      setDistForm({ ...distForm, [name]: value });
    }

    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const validateContact = () => {
    const e = {};
    if (!contactForm.name.trim()) e.name = "Name is required";
    if (!contactForm.email.trim()) e.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(contactForm.email)) e.email = "Invalid email";
    if (contactForm.phone && !/^[0-9]{10}$/.test(contactForm.phone)) e.phone = "Enter valid 10-digit number";
    if (!contactForm.message.trim()) e.message = "Message is required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const validateDistributor = () => {
    const e = {};
    if (!distForm.name.trim()) e.name = "Name required";
    if (!distForm.email.trim()) e.email = "Email required";
    if (!distForm.phone.trim()) e.phone = "Phone required";
    if (!distForm.city.trim()) e.city = "City required";
    if (!distForm.state.trim()) e.state = "State required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let text = "";

    if (activeForm === "contact") {
      if (!validateContact()) return;

      text = `
New Inquiry from Website

Name: ${contactForm.name}
Phone: ${contactForm.phone}
Email: ${contactForm.email}
Subject: ${contactForm.subject}

Message:
${contactForm.message}
`;

      setContactForm({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } else {
      if (!validateDistributor()) return;

      text = `
Distributor Inquiry

Name: ${distForm.name}
Email: ${distForm.email}
Phone: ${distForm.phone}
City: ${distForm.city}
State: ${distForm.state}

Business: ${distForm.business}
Experience: ${distForm.years}

Message:
${distForm.message}
`;

      setDistForm({
        name: "",
        email: "",
        phone: "",
        city: "",
        state: "",
        business: "",
        years: "",
        message: "",
      });
    }

    window.open("https://wa.me/919320905751?text=" + encodeURIComponent(text), "_blank");
    setSent(true);
  };

  return (


    <main className="cp-page">
       <Helmet>
        <title>Contact Prakhyat Agarbatti | Distributor Inquiry — Mumbai</title>
        <meta
          name="description"
          content="Contact Prakhyat Agarbatti for product inquiries, bulk orders & distributor partnerships. Call +91 93209 05751 or WhatsApp us. Office at Virar East, Palghar, Maharashtra. Mon–Sat 9AM–7PM."
        />
        <meta
          name="keywords"
          content="prakhyat agarbatti contact, agarbatti distributor inquiry, bulk agarbatti order, agarbatti wholesale india, agarbatti manufacturer virar, agarbatti palghar, incense distributor india, agarbatti bulk supply, prakhyat contact number, agarbatti wholesale mumbai"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://prakhyatagarbatti.com/contact" />
      </Helmet>

      <section
        className="page-hero"
        style={{ backgroundImage: `url(${heroImg})`,
        backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
       }}
      >
        <div className="overlay"></div>
        <div className="hero-content container">
          <div className="hero-badge reveal">Get in Touch</div>
          <h1 className="reveal">Contact Us</h1>
          <p className="reveal">
            Connect with Prakhyat for product inquiries, bulk orders and distributor partnerships.
          </p>
        </div>
      </section>

      <section className="cp-main section">
        <div className="container">
          <div className="cp-layout">
            <div className="cp-left reveal-l">
              <span className="cp-eyebrow">Reach Out</span>

              <h2 className="cp-left-h2">
                We'd Love to <br /> Hear From You
              </h2>

              <p className="cp-left-p">
                Send us your requirement and our team will guide you with product details,
                pricing, availability and partnership opportunities.
              </p>

              <div className="cp-info-grid">
                <a href="tel:+919320905751" className="cp-info-card">
                  <div className="cp-info-ico"><i className="ri-phone-fill" /></div>
                  <div><small>Phone</small><strong>+91 93209 05751</strong></div>
                </a>

                <a href="https://wa.me/919320905751" target="_blank" rel="noreferrer" className="cp-info-card">
                  <div className="cp-info-ico"><i className="ri-whatsapp-fill" /></div>
                  <div><small>WhatsApp</small><strong>Chat With Us</strong></div>
                </a>

                <a href="mailto:info@prakhyatagarbatti.com" className="cp-info-card">
                  <div className="cp-info-ico"><i className="ri-mail-fill" /></div>
                  <div><small>Email</small><strong>info@prakhyatagarbatti.com</strong></div>
                </a>

                <div className="cp-info-card">
                  <div className="cp-info-ico"><i className="ri-time-fill" /></div>
                  <div><small>Working Hours</small><strong>Mon–Sat, 9 AM – 7 PM</strong></div>
                </div>
              </div>

              <div className="cp-address">
                <span className="cp-address-label">
                  <i className="ri-map-pin-2-fill" /> Office Address
                </span>
                <p>
                  Gala No. 205, 2nd Floor, Bldg No. 16, HDIL Ind Park,
                  CSL Chandansar Road, Near Riddhi Ind Est,<br />
                  Virar East, Dist. Palghar – 401303, Maharashtra
                </p>
                <a href="https://maps.google.com/?q=Virar+East+Palghar+Maharashtra" target="_blank" rel="noreferrer" className="cp-map-link">
                  <i className="ri-external-link-line" /> Open in Google Maps
                </a>
              </div>

              <div className="cp-benefit-box">
                <h3>Why Partner With Prakhyat?</h3>
                {[
                  "Exclusive territory rights",
                  "High margins",
                  "Marketing support",
                  "Regular product launches",
                  "Direct factory pricing from mumbai",
                  "Training and product knowledge",
                ].map((item, i) => (
                  <div className="cp-benefit" key={i}>
                    <i className="ri-check-double-line" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="cp-right reveal-r">
             <div className="cp-form-switch">
  <button
    className={activeForm === "distributor" ? "active" : ""}
    onClick={() => { setActiveForm("distributor"); setSent(false); setErrors({}); }}
  >
    <i className="ri-handshake-line" /> Distributor
  </button>
  <button
    className={activeForm === "contact" ? "active" : ""}
    onClick={() => { setActiveForm("contact"); setSent(false); setErrors({}); }}
  >
    <i className="ri-message-3-line" /> General Inquiry
  </button>
</div>

              {sent ? (
                <div className="cp-success">
                  <div className="cp-success-ring">
                    <div className="cp-success-ico"><i className="ri-check-line" /></div>
                  </div>
                  <h3>Thank You!</h3>
                  <p>Your message is ready on WhatsApp. Our team will reply shortly.</p>
                  <button className="cp-reset-btn" onClick={() => setSent(false)}>
                    Send Another
                  </button>
                </div>
              ) : (
                <div className="cp-form-card">
                  <div className="cp-form-head">
                    <span>{activeForm === "contact" ? "Quick Inquiry" : "Partnership"}</span>
                    <h3>{activeForm === "contact" ? "Send Your Requirement" : "Distributor Application"}</h3>
                    <p>Fill the form and connect directly on WhatsApp.</p>
                  </div>

                  <form onSubmit={handleSubmit} className="cp-form">
                    <div className="cp-row">
                      <div className="cp-fg">
                        <label>Full Name <em>*</em></label>
                        <input name="name" value={activeForm === "contact" ? contactForm.name : distForm.name} onChange={hc} placeholder="Your full name" />
                        {errors.name && <span className="cp-err">{errors.name}</span>}
                      </div>

                      <div className="cp-fg">
                        <label>Phone {activeForm === "distributor" && <em>*</em>}</label>
                        <input name="phone" value={activeForm === "contact" ? contactForm.phone : distForm.phone} onChange={hc} placeholder="10-digit number" />
                        {errors.phone && <span className="cp-err">{errors.phone}</span>}
                      </div>
                    </div>

                    <div className="cp-fg">
                      <label>Email Address <em>*</em></label>
                      <input type="email" name="email" value={activeForm === "contact" ? contactForm.email : distForm.email} onChange={hc} placeholder="you@example.com" />
                      {errors.email && <span className="cp-err">{errors.email}</span>}
                    </div>

                    {activeForm === "contact" ? (
                      <>
                        <div className="cp-fg">
                          <label>Subject</label>
                          <select name="subject" value={contactForm.subject} onChange={hc}>
                            <option value="">Select a topic</option>
                            <option>Product Inquiry</option>
                            <option>Bulk Order</option>
                            <option>Distributor Partnership</option>
                            <option>Custom Packaging</option>
                            <option>Other</option>
                          </select>
                        </div>

                        <div className="cp-fg">
                          <label>Your Message <em>*</em></label>
                          <textarea name="message" value={contactForm.message} onChange={hc} rows="5" placeholder="Tell us your requirement..." />
                          {errors.message && <span className="cp-err">{errors.message}</span>}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="cp-row">
                          <div className="cp-fg">
                            <label>City / District <em>*</em></label>
                            <input name="city" value={distForm.city} onChange={hc} placeholder="City" />
                            {errors.city && <span className="cp-err">{errors.city}</span>}
                          </div>

                          <div className="cp-fg">
                            <label>State <em>*</em></label>
                            <input name="state" value={distForm.state} onChange={hc} placeholder="State" />
                            {errors.state && <span className="cp-err">{errors.state}</span>}
                          </div>
                        </div>

                        <div className="cp-fg">
                          <label>Current Business</label>
                          <input name="business" value={distForm.business} onChange={hc} placeholder="Wholesale / Retail / Trading etc." />
                        </div>

                        <div className="cp-fg">
                          <label>Years in Business</label>
                          <select name="years" value={distForm.years} onChange={hc}>
                            <option value="">Select</option>
                            <option>0–2 Years</option>
                            <option>2–5 Years</option>
                            <option>5–10 Years</option>
                            <option>10+ Years</option>
                          </select>
                        </div>

                        <div className="cp-fg">
                          <label>Why Prakhyat?</label>
                          <textarea name="message" rows="4" value={distForm.message} onChange={hc} placeholder="Tell us about your network and interest..." />
                        </div>
                      </>
                    )}

                    <button type="submit" className="cp-submit-btn">
                      <i className="ri-whatsapp-fill" />
                      {activeForm === "contact" ? "Send via WhatsApp" : "Submit Application"}
                      <i className="ri-arrow-right-line cp-submit-arrow" />
                    </button>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}